import React from "react";
import {
  getSelectedLocations,
  getLocationsFilterOptions,
  getSelectedLocationDescription,
} from "state/ui/location-filter/selectors";
import {
  setLocationsFilterOptions,
  setSelectedLocations,
} from "../../state/ui/location-filter/actions";
import vd from "lib/vd";
import { connect } from "react-redux";
import PopoverMenu from "components/popover/menu";
import "./styles.scss";
import { Box, Stack } from "@towersystems/towersystems-design-system";
import Button from "components/button";
import Icon from "../../components/icon";
import classnames from "classnames";
import { ButtonV2 } from "components/button-v2";
import { Text } from "../../components/text";

const LocationFilterDropdown = ({
  selectedLocations,
  locationFilterOptions,
  setLocationsFilterOptions,
  setSelectedLocations,
  description,
}) => {
  const [checked, setChecked] = React.useState([]);
  const [isVisible, setIsVisible] = React.useState(false);

  React.useEffect(() => {
    if (selectedLocations.length === 0) {
      vd.location()
        .listAll()
        .then((locations) => {
          setLocationsFilterOptions(locations || []);
        })
        .catch((err) => console.log);
    }
  }, []);

  React.useEffect(() => {
    if (isVisible) {
      setChecked(selectedLocations);
    } else {
      setChecked([]);
    }
  }, [selectedLocations.length, isVisible]);

  const handleOnSubmit = () => {
    setSelectedLocations(checked);
    setIsVisible(false);
  };

  const canActivate = locationFilterOptions.length > 1;

  const activatorMarkup = (
    <div
      className={classnames(
        "location-filter-dropdown__activator",
        !canActivate && "not-active",
      )}
      onClick={() => canActivate && setIsVisible(true)}
    >
      <Icon name="FaLocationDot" type="fa6" marginRight={10} />
      <Text variant="headingXxs">{description || "All Locations"}</Text>
      {locationFilterOptions.length > 1 && (
        <Icon name="FaCaretDown" type="fa" marginLeft={10} size={10} />
      )}
    </div>
  );

  const isDisabled = checked === selectedLocations;

  const popoverContent = (
    <Box className="location-filter-dropdown__content" padding="large">
      <Box
        paddingBottom="large"
        justifyContent="spaceBetween"
        alignItems="center"
        display="flex"
      >
        <Text variant="headingXs">Select Locations</Text>
        {checked.length >= 1 ? (
          <Box>
            <Button
              onClick={(e) => {
                e.stopPropagation();
                setChecked([]);
              }}
              text
            >
              Clear all
            </Button>
          </Box>
        ) : undefined}
      </Box>
      <Box>
        <Stack space="medium">
          {locationFilterOptions.map((location) => {
            const isChecked = checked.includes(location.locationCode);
            return (
              <div class="flex items-center gap-2" key={location.locationCode}>
                <input
                  type="checkbox"
                  checked={isChecked}
                  value={location.locationCode}
                  onChange={() => {
                    if (isChecked) {
                      setChecked(
                        checked.filter((l) => l !== location.locationCode),
                      );
                    } else {
                      setChecked([...checked, location.locationCode]);
                    }
                  }}
                />
                <div class="ml-1 flex items-center">
                  <Text variant="bodyMd">{location.name}</Text>
                </div>
              </div>
            );
          })}
        </Stack>
      </Box>
      <div className="flex gap-3 mt-6">
        <ButtonV2
          disabled={isDisabled}
          fullWidth
          onClick={handleOnSubmit}
          filled
          variant="primary"
        >
          Apply
        </ButtonV2>
        <ButtonV2 fullWidth onClick={() => setIsVisible(false)}>
          Cancel
        </ButtonV2>
      </div>
    </Box>
  );

  return (
    <div>
      <PopoverMenu
        className="location-filter-dropdown"
        enterExitTransitionDurationMs={50}
        onOuterAction={() => setIsVisible(false)}
        isOpen={isVisible}
        showArrow={true}
        content={popoverContent}
      >
        {activatorMarkup}
      </PopoverMenu>
    </div>
  );
};

export default connect(
  (state) => ({
    selectedLocations: getSelectedLocations(state),
    locationFilterOptions: getLocationsFilterOptions(state),
    description: getSelectedLocationDescription(state),
  }),
  {
    setLocationsFilterOptions,
    setSelectedLocations,
  },
)(LocationFilterDropdown);
